module.exports = __webpack_public_path__ + "media/images/lb/960-37835629363a703161f4ad173a9a0178.svg";